import React, { useState } from "react";
import axios from "axios";

function useFetchFormatedData(
  endpoint,
  method,
  options = {},
  keyName,
  labelName,
  rerenderingCondition,
  combineValueKey,
  combineValue,
) {
  const [data, setData] = React.useState(null);
  const [loading, setLoading] = React.useState(false);
  const [error, setError] = React.useState(null);
  const [message, setMessage] = useState(null);

  React.useEffect(() => {
    const fetchData = async () => {
      try {
        setLoading(true);
        let response;
        if (method.toUpperCase() === "GET") {
          response = await axios.get(endpoint, options);
        } else if (method.toUpperCase() === "POST") {
          response = await axios.post(endpoint, options.data, {
            headers: options.headers,
          });
        }
        setData(
          response.data.data?.map((item) => ({
            value: combineValueKey
              ? `${item[keyName]},${item[combineValueKey]}`
              : item[keyName],
            label: item[labelName],
            id: item.id,
          })),
        );
        setMessage(response?.data.message);
      } catch (err) {
        setError(err);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, [endpoint, rerenderingCondition, combineValue, combineValueKey]);

  return { data, loading, error, message };
}

export default useFetchFormatedData;
